/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PartnerIntentRequest } from "./PartnerIntentRequest";
import type { ProgramID } from "./ProgramID";
import type { ThemeEnum } from "./ThemeEnum";
import type { WorkflowType } from "./WorkflowType";

export interface CreateConversationRequest {
  initial_workflow_type?: WorkflowType | null;
  use_case?: ThemeEnum | null;
  partner_intent?: PartnerIntentRequest | null;
  source_conversation_id?: string | null;
  conversation_group_id?: string | null;
  program?: ProgramID | null;
}
